import React, { Component } from "react";
import { Redirect } from "react-router";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import vipService from "../../../services/VipService";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import Loading from "./../../Nano/Loading.js";
import { urlExists } from "../../Global/tools.js";
import SingleSelectionDropdown from "./../../Nano/SingleSelectionDropdown.js";

import Input from "../../Nano/Input.js";
import { ReactComponent as SearchIcon } from "../../Global/Icons/search.svg";

// IMAGES
import { ReactComponent as PlayIcon } from "../../Global/Icons/play.svg";
import { ReactComponent as Download } from "../../Global/Icons/download.svg";
import DefaultVideo from "../../../images/defaultVideo.svg";
// import download from ".../../Global/Icons/download.svg";
import NotaIcon from "../../Global/Icons/nota-icon.svg";

const multiple = nota.global.multiple;

const StyledReports = styled(NanoFlex)`
  /* width: 100%; */
  height: 100%;
  padding: ${multiple * 2 + "px"};
  .viewWrapper {
    .headerWrapper {
      height: auto;
      h2 {
        text-transform: uppercase;
        em {
          text-transform: none;
          font-weight: bold;
          color: ${nota.color.main.default};
        }
      }
      p {
        margin-left: ${multiple * 2 + "px"};
        margin-bottom: 2px;
      }
    }
    .asideWrapper {
      padding-top: ${multiple * 2 + "px"};
      .asideContainer {
        /* width: 30%; */
        width: 55%;
        margin-left: ${multiple * 2 + "px"};
        padding: 0 32px;
        .infoReportWrapper {
          padding-top: ${multiple * 2 + "px"};
          height: auto;
          .infoReport {
            h3 {
              margin-bottom: ${multiple * 2 + "px"};
              font-weight: bold;
              color: ${nota.color.main.defaultTwo};
              em {
                color: ${nota.color.main.mOne};
              }
            }

            .htmlSummary {
              ol,
              ul {
                list-style: revert;
                padding-left: 25px;
              }
              a {
                text-decoration: none;
                color: ${nota.color.main.default};

                &:hover {
                  text-decoration: underline;
                  text-decoration-color: ${nota.color.main.default};
                }
              }
            }
          }
        }
        .inputContainer {
          margin: 0;
          width: 100%;
        }
      }
      .biggerAside {
        /* width: 65%; */
        /* padding-right: 5%; */
        width: 100%;
        margin-left: 0;
        padding: 0;
      }
    }
  }

  /* VIDEO */

  .videoContainer {
    height: auto;
    .videoWrapper {
      position: relative;
      height: auto;
      .imgVideoWrapper {
        width: 100%;
        overflow: hidden;
        background-color: ${nota.color.neutral.NeuTwo};
        position: relative;
        padding-bottom: calc(633.44 / 1127.34 * 100%);
        video,
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .iconVideoWrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
          transition: all 0.3s ease-in-out;
        }
      }
      &:hover {
        .iconVideoWrapper {
          img {
            transition: all 0.3s ease-in-out;
            transform: scale(1.2);
          }
        }
      }
    }
  }

  .btnsWrapper {
    width: auto;
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 168, 225, 0.5);
    .iconBtnWrapper {
      padding: ${multiple + "px"};
      margin: 0 ${multiple + "px"};
      cursor: pointer;
      svg {
        height: auto;
        width: 20px;
        path,
        rect {
          fill: ${nota.color.neutral.white};
        }
      }
      &:hover {
        opacity: 0.7;
      }
    }
  }

  /* CTA DOWNLOAD */
  .downloadCtaWrapper {
    width: 250px;
    .downloadCta {
      max-width: 100px;
      min-height: 105px;
      background-color: ${nota.color.neutral.white};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      padding: ${multiple / 2 + "px"}; /* 4px */
      position: relative;
      cursor: pointer;
      .wrapperTop {
        padding: ${multiple + "px"}; /* 8px */
        background-color: ${nota.color.main.default};
        position: relative;
        height: 72px;
        h4 {
          text-transform: uppercase;
          b {
            color: ${nota.color.neutral.white};
          }
        }
        &:after {
          content: "";
          display: block;
          position: absolute;
          bottom: -7px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 7px solid ${nota.color.main.default};
        }
      }
      p {
        color: ${nota.color.main.default};
        font-size: 11px;
        text-align: center;
        margin-top: 6px;
      }
      .iconWrapper {
        position: absolute;
        top: -16px;
        right: -16px;
        width: 35px;
        height: 35px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        background-color: ${nota.color.neutral.white};
        border-radius: 100%;
      }
      &:hover {
        opacity: 0.7;
      }
    }
    @media only screen and (max-width: ${nota.global.breakpoints.smallTablet + "px"}) {
      width: 150px;
      .downloadCta {
        transform: scale(0.6);
      }
    }
  }

  /* LIST */
  .listContainer {
    background-color: ${nota.color.neutral.lightGrey};
    margin-top: ${multiple * 2 + "px"};
    background: ${nota.color.neutral.lightGrey};
    min-height: 264px;
    background-image: url(${NotaIcon});
    background-repeat: no-repeat, repeat;
    background-size: 50% 50%;
    background-position: center;

    .listWrapper {
      padding: ${multiple * 2 + "px"};
      padding-bottom: 4px;
      overflow: auto;
      /* max-height: 72vh; */
      height: calc(100vh - 225px);
      .itemList {
        cursor: pointer;
        height: 100px;
        min-height: -webkit-fit-content;
        background-color: ${nota.color.neutral.white};
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
        margin-bottom: ${multiple + "px"};
        .labelItem {
          width: auto;
          padding: ${multiple + "px"};
          background: ${nota.color.secondary.secFive};
          h5 {
            color: ${nota.color.neutral.white};
            font-weight: bold;
            &:after {
              content: "";
              display: block;
              width: 100%;
              height: 1px;
              background-color: ${nota.color.neutral.white};
              margin: ${multiple / 2 + "px"} 0;
            }
            &:last-child {
              &:after {
                display: none;
              }
            }
          }
        }
        .infoItem {
          padding: ${multiple * 2 + "px"};
          .titleItem {
            h4 {
              margin-bottom: ${multiple + "px"};
              font-weight: bold;
              color: ${nota.color.main.defaultTwo};
              overflow: hidden;
              text-overflow: ellipsis;
              /* white-space: nowrap; */
              em {
                color: ${nota.color.main.mOne};
              }
            }
          }
          .textWrapper {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-box-align: start;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
        /* &:hover {
          .labelItem {
            background-color: ${nota.color.main.mOne};
          }
        } */
      }
      .selected {
        .labelItem {
          background-color: ${nota.color.main.mOne};
        }
        .infoItem {
          border: 1px solid ${nota.color.main.mOne};
        }
      }
    }
  }

  .inputWrapper {
    width: 100%;
    height: auto;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      height: auto;
      right: ${multiple + "px"};
      top: 9px;
      width: ${multiple * 3 + "px"};
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 968px) {
    .viewWrapper {
      .asideWrapper {
        .asideContainer {
          width: 100%;
        }
      }
    }
  }
  @media only screen and (max-width: 800px) {
    .viewWrapper {
      .headerWrapper {
        flex-direction: column;
        align-items: flex-start;
        p {
          margin-top: ${multiple + "px"};
          margin-left: 0px;
          margin-bottom: 0px;
        }
      }
      .dropdownWrapper {
        margin: 24px 0;
        .dropDownContainer {
          width: 100%;
        }
      }
      .asideWrapper {
        flex-direction: column;
        padding-top: 0px;
      }
    }
  }
`;

const StyledLoading = styled(NanoFlex)`
  height: calc(100vh - 98px);
`;

class ReportsItem extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();

    this.downloadVideoRef = React.createRef();
    this.videoRef = React.createRef();
  }

  getDefaultState = () => {
    return {
      openVideo: false,
      hasVideo: false,
      hasPdf: false,
      hasImage: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("displaySearchChanged", this.onDisplaySearchChanged, false);
    window.addEventListener("visibilitychange", this.onVisibilitychange, false);

    this.validateUrl();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.props.item) !== JSON.stringify(prevProps.item)) {
      this.setState(this.getDefaultState, () => {
        this.validateUrl();
      });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("displaySearchChanged", this.onDisplaySearchChanged, false);
    window.removeEventListener("visibilitychange", this.onVisibilitychange, false);
  }

  onDisplaySearchChanged = (e) => {
    if (e.detail === true) {
      if (this.videoRef?.current?.pause) this.videoRef.current.pause();
    }
  };

  onVisibilitychange = () => {
    if (this.videoRef?.current?.pause) this.videoRef.current.pause();
  };

  validateUrl = () => {
    urlExists(this.props.item.image, (val) => {
      this.setState({ hasImage: val });
    });
    urlExists(this.props.item.video, (val) => {
      this.setState({ hasVideo: val });
    });
    urlExists(this.props.item.pdf, (val) => {
      this.setState({ hasPdf: val });
    });
  };

  openVideo = () => {
    this.setState({ openVideo: true }, () => {
      this.videoRef.current.play();
    });
  };

  downloadVideo = () => {
    this.downloadVideoRef.current.click();
  };

  openPdf = () => {
    vipService
      .getReportPdf(this.props.item.pdf)
      .then((response) => {
        if (response.ok) {
          return response.blob();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
        return null;
      })
      .then((blob) => {
        if (blob) {
          window.open(window.URL.createObjectURL(blob), "_blank");
        }
      });
  };

  render() {
    return (
      <NanoFlex className="asideContainer biggerAside" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
        {(this.state.hasImage || this.state.hasVideo) && (
          <NanoFlex className="videoContainer">
            <NanoFlex className="videoWrapper">
              <div className="imgVideoWrapper">
                {(this.state.openVideo || !this.state.hasImage) && (
                  // {...(!this.state.hasImage ? { autoplay: true } : {})}
                  <video ref={this.videoRef} {...(this.state.openVideo ? { controls: true } : {})}>
                    <source src={`${this.props.item.video}#t=0.1`} type="video/mp4" />
                  </video>
                )}
                {!this.state.openVideo && this.state.hasImage && <img src={this.props.item.image} alt="Default Card" />}
              </div>
              {!this.state.openVideo && this.state.hasVideo && (
                <NanoFlex className="btnsWrapper">
                  <NanoFlex className="iconBtnWrapper" onClick={this.openVideo}>
                    <PlayIcon />
                  </NanoFlex>
                  <NanoFlex className="iconBtnWrapper" onClick={this.downloadVideo}>
                    <Download />
                    <a className="videoDownloadHidden" ref={this.downloadVideoRef} href={this.props.item.video} download />
                  </NanoFlex>
                </NanoFlex>
              )}
            </NanoFlex>
          </NanoFlex>
        )}
        <NanoFlex className="infoReportWrapper" justifyContent={"flex-start"} alignItems={"flex-start"}>
          <NanoFlex className="infoReport" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            <Type.h3>
              {/* <em>Monthly Highlights</em> - */}
              {this.props.item.title}
            </Type.h3>
            <Type.p className="htmlSummary" justify dangerouslySetInnerHTML={{ __html: this.props.item.htmlSummary }}></Type.p>
          </NanoFlex>
          {this.state.hasPdf && (
            <NanoFlex className="downloadCtaWrapper">
              <div className="downloadCta" onClick={this.openPdf}>
                <NanoFlex className="wrapperTop">
                  <Type.h4>
                    <b>{this.translation.reports.readReport}</b>
                  </Type.h4>
                </NanoFlex>
                <Type.p>
                  <em>{this.translation.reports.downloadPdf}</em>
                </Type.p>
                <NanoFlex className="iconWrapper">
                  <Download />
                  {/* <img src={download} alt="download" /> */}
                </NanoFlex>
              </div>
            </NanoFlex>
          )}
        </NanoFlex>
      </NanoFlex>
    );
  }
}

export class Reports extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();

    this.downloadVideoRef = React.createRef();
  }

  getDefaultState = () => {
    return {
      selectedReport: null,
      reports: null,

      redirectTo: "",
    };
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onReportsLanguageChange, false);

    /*Redirect if it has no access to Reports */
    if (!vipService.getUser()?.PagesAuthorization?.HasNotaSelection) this.props.render.history.push("/");

    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.redirectTo) this.setState({ redirectTo: "" });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onReportsLanguageChange, false);
  }

  onReportsLanguageChange = () => {
    this.setState(this.getDefaultState(), () => {
      this.getAllData();
    });
  };

  getAllData = () => {
    this.getReports();
  };

  getReports = () => {
    vipService
      .getReports()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ reports: data, selectedReport: data?.length > 0 ? data[0] : {}, redirectTo: !data || data.length == 0 ? "/" : "" });
      });
  };

  onItemClick = (item) => {
    this.setState({ selectedReport: item });
  };

  onSelectionChange = (item) => {
    let newItem = this.state.reports?.find((r) => r.idLetter === item?.id);
    if (newItem) {
      this.setState({ selectedReport: newItem });
    }
  };

  render() {
    if (this.state.redirectTo) return <Redirect to={this.state.redirectTo} />;

    if (this.state.reports == null)
      return (
        <StyledLoading className="loadingContainer">
          <Loading />
        </StyledLoading>
      );

    return (
      <StyledReports className="report">
        <NanoFlex className="viewWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-end"}>
            <Type.h2>
              <em>{this.translation.notaReports.title}</em>
            </Type.h2>
            <Type.p>{this.translation.notaReports.subTitle}</Type.p>
          </NanoFlex>
          {this._isMobile && (
            <NanoFlex className="dropdownWrapper">
              <SingleSelectionDropdown
                options={
                  this.state.reports?.map((item) => {
                    return { id: item.idLetter, name: item.title };
                  }) ?? []
                }
                selected={this.state.selectedReport.idLetter}
                onChangeSelection={this.onSelectionChange}
              />
            </NanoFlex>
          )}
          <NanoFlex className="asideWrapper" justifyContent={"space-between"} alignItems={"flex-start"}>
            <ReportsItem item={this.state.selectedReport} />
            {!this._isMobile && <ReportsList data={this.state.reports} selectedIdLetter={this.state.selectedReport.idLetter} onItemClick={this.onItemClick} />}
          </NanoFlex>
        </NanoFlex>
      </StyledReports>
    );
  }
}

class ReportsList extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      term: "",
    };

    this.listWrapperRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onTermChange = (value) => {
    this.setState({ term: value, page: 1 });
  };

  getFilteredResults = () => {
    /*Currently Includes filter instead of StartsWith (Validate Later) */
    if (this.state.term.trim() !== "") {
      let upperTerm = this.state.term.trim().toUpperCase();
      return this.props.data.filter((v) => {
        let upperTitle = v.title.trim().toUpperCase();
        let upperSummary = v.summary.trim().toUpperCase();
        return upperTitle.includes(upperTerm) || upperSummary.includes(upperTerm);
      });
    } else {
      return this.props.data;
    }
  };

  render() {
    return (
      <NanoFlex className="asideContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
          <Input title={null} defaultValue={this.state.term} placeholder={this.translation.geral.search + "..."} onChangeAction={this.onTermChange} />
          <NanoFlex className="searchIconWrapper">
            <SearchIcon />
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="listContainer" alignItems={"flex-start"}>
          <NanoFlex ref={this.listWrapperRef} className="listWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            {this.props.data &&
              this.getFilteredResults().map((item) => {
                let startMonthSplit = item.startMonth.split("/");
                return (
                  <NanoFlex
                    className={`itemList ${item.idLetter === this.props.selectedIdLetter ? "selected" : ""}`}
                    key={"Letter_" + item.idLetter}
                    onClick={() => {
                      this.props.onItemClick(item);
                    }}
                  >
                    <NanoFlex className="labelItem" flexDirection={"column"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                      <Type.h5>
                        {/* Month */}
                        {startMonthSplit[0]}
                      </Type.h5>
                      <Type.h5>
                        {/* Year (Get last 2 chars)*/}
                        {startMonthSplit[1].slice(-2)}
                      </Type.h5>
                    </NanoFlex>
                    <NanoFlex className="infoItem" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                      <NanoFlex className="titleItem" justifyContent={"flex-start"} alignItems={"flex-start"}>
                        <Type.h4>
                          {/* <em>Focus Genre</em> - */} {item.title}
                        </Type.h4>
                      </NanoFlex>
                      <NanoFlex className="textWrapper">
                        {/* <Type.p>{item.summary.length > 75 ? item.summary.substring(0, 75) + "..." : item.summary}</Type.p> */}
                        <Type.p>{item.summary}</Type.p>
                      </NanoFlex>
                    </NanoFlex>
                  </NanoFlex>
                );
              })}
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}
